import styled from 'styled-components';
import { ClearButton } from '@morressier/ts';

const LinkButton = styled(ClearButton)<{ isDisable?: boolean }>`
  color: ${props => (props.isDisable ? 'grey' : 'var(--color-blue-40)')};
  font-size: var(--fontSizes-normal);
  display: flex;
  align-items: center;
  gap: 4px;
  pointer-events: ${props => (props.isDisable ? 'none' : '')};
  border-radius: 0.25rem;
  &:hover,
  &:focus {
    color: var(--color-blue-20);
  }
`;
export default LinkButton;
